// extracted by mini-css-extract-plugin
module.exports = {"root":"Overlay_root__clxcM","absolute":"Overlay_absolute__GKMlp","fixed":"Overlay_fixed__Q9Zrp","dark":"Overlay_dark__oZVAn","blur":"Overlay_blur__LOxaA"};